import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { UserContextService } from './user-context.service';

/**
 * Вход в задачу эксперта из письма: не требует SelectedBF / ОЕ.
 * Достаточно загруженного пользователя (даже без БФ в контексте).
 */
export const activateExpertTaskGuard: CanActivateFn = () => {
  const userContextSvc = inject(UserContextService);
  const router = inject(Router);

  return userContextSvc.getUserContext().pipe(
    map((x) => {
      if (!x) {
        router.navigate(['/403']);
        return false;
      }
      return true;
    })
  );
};
